var map = {
	"./cn/北京通州华仁学校/pc.svg": "pHW1",
	"./en/北京通州华仁学校/pc.svg": "3mDn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PVIg";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\/北京通州华仁学校\/pc\.svg$
// module id = PVIg
// module chunks = 16